$(document).ready(function() {
  overflowParentHeight();
  mainMenu();
  animations();
  artistFilter();
  imageGallery();
  grayBackground();
  headerScroll();

});
$(window).resize(function() {
  overflowParentHeight();
  grayBackground();
});

// Recalculate height if images load late
$(window).on("load", function() {
  overflowParentHeight();
  setTimeout(function() {
    overflowParentHeight();
  }, 500);
});

function mainMenu() {
  $("#menuToggle").on("click", function(e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $("body").toggleClass("menu-open");
  });
}

function overflowParentHeight() {
  // Checks height of overflow content and sets it to the parent
  $(".overflow-parent > *").each(function() {
    heightAdjust = $(this).outerHeight();
    $(this)
      .closest(".overflow-parent")
      .height(heightAdjust);
  });
}

function animations() {
  // Animation classes
  window.sr = ScrollReveal();
  sr.reveal(".animate.slide-right", {
    distance: "100%",
    origin: "left",
    duration: 1000,
    delay: 100
  });
  sr.reveal(".animate.slide-left", {
    distance: "100%",
    origin: "right",
    duration: 1000,
    delay: 100
  });
  sr.reveal(".animate.slide-up", {
    distance: "55px",
    origin: "bottom",
    duration: 1000,
    delay: 100
  });
  sr.reveal(".animate.fade-in", {
    duration: 1000,
    delay: 100,
    interval: 100
  });

  sr.reveal(".animate.slide-right.late", {
    distance: "100%",
    origin: "left",
    duration: 1000,
    delay: 300
  });
  sr.reveal(".animate.slide-left.late", {
    distance: "100%",
    origin: "right",
    duration: 1000,
    delay: 300
  });
  sr.reveal(".animate.slide-up.late", {
    distance: "55px",
    origin: "bottom",
    duration: 1000,
    delay: 300
  });
  sr.reveal(".animate.fade-in.late", {
    duration: 1000,
    delay: 300,
    interval: 100
  });

  sr.reveal(".animate.slide-right.later", {
    distance: "100%",
    origin: "left",
    duration: 1000,
    delay: 700
  });
  sr.reveal(".animate.slide-left.later", {
    distance: "100%",
    origin: "right",
    duration: 1000,
    delay: 700
  });
  sr.reveal(".animate.slide-up.later", {
    distance: "55px",
    origin: "bottom",
    duration: 1000,
    delay: 700
  });
  sr.reveal(".animate.fade-in.later", {
    duration: 1000,
    delay: 700,
    interval: 100
  });
  $(".show-on-js-load").css("visibility", "visible");
}

function artistFilter() {
  $("#artistFilter input").on("change", function() {
    var height = $("#artistArticleWrapper").height();
    var artistWrapper = $("#artistArticleWrapper");
    var filter = $(this).val();

    artistWrapper.css("height", height);

    var mydata = {
      action: "artist_filter",
      category: filter
    };

    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "html",
      data: mydata,
      success: function(result) {
        artistWrapper.html(result);
        console.log();
        setTimeout(function() {
          artistWrapper.css("height", "auto");
          animations();
        }, 100);
      }
    });
    return false;
  });
}

function imageGallery() {
  if(!$(".gallery-image").length ) {
    $('.image-gallery').hide();
  }
  var tbaCurrentImageKey = 0,
    lightbox = null,
    tbaGalleryImages = window.tbaGalleryImages;
  var updateGalleryImage = function(direction) {
    if (
      tbaCurrentImageKey === tbaGalleryImages.length - 1 &&
      direction === "next"
    ) {
      tbaCurrentImageKey = 0;
    } else if (tbaCurrentImageKey === 0 && direction === "previous") {
      tbaCurrentImageKey = tbaGalleryImages.length - 1;
    } else {
      tbaCurrentImageKey =
        direction === "next" ? tbaCurrentImageKey + 1 : tbaCurrentImageKey - 1;
    }
    lightbox.find("figure").fadeOut(150, function() {
      $(this)
        .find("img")
        .remove();
      $(this).prepend(tbaGalleryImages[tbaCurrentImageKey]["image"]);
      $(this)
        .find("figcaption")
        .html("<p>" + tbaGalleryImages[tbaCurrentImageKey]["caption"] + "</p>");
      $(this).fadeIn(250);
    });
  };

  var closeGalleryOverlay = function() {
    if ($("#gallery-lightbox").length > 0) {
      $("#gallery-lightbox").fadeOut(500, function() {
        $("#gallery-lightbox").remove();
        $(".selected-image").trigger("focus");
      });
    }
  };

  var openArtist = function(el) {
    $(el)
      .siblings(".artist-text-content")
      .addClass("active");
    $("html").css("overflow-y", "hidden");
  };

  var closeArtist = function(el) {
    $(el)
      .closest(".artist-text-content")
      .removeClass("active");
    $(el)
      .closest(".artist-text-content")
      .find("iframe")
      .each(function() {
        $(this).attr("src", $(this).attr("src"));
      });
    $("html").css("overflow-y", "auto");
  };

  $(document)
    .on("click", "#gallery-next", function(e) {
      e.preventDefault();
      e.stopPropagation();
      updateGalleryImage("next");
    })
    .on("click", "#gallery-prev", function(e) {
      e.preventDefault();
      e.stopPropagation();
      updateGalleryImage("previous");
    })
    .on("click", "#gallery-close", function(e) {
      e.preventDefault();
      closeGalleryOverlay();
    })
    .on("click", ".gallery-images a", function(e) {
      e.preventDefault();
      $(this).addClass("selected-image");
      tbaCurrentImageKey = $(this)
        .closest(".column-block")
        .index();
      if ($("#gallery-lightbox").length <= 0) {
        $("body").append(
          '<div id="gallery-lightbox"><button id="gallery-close"><span>' +
            dcdata.close +
            '</span></button><figure id="large-gallery-image"></figure><button id="gallery-prev"><span>' +
            dcdata.previous +
            '</span></button><button id="gallery-next"><span>' +
            dcdata.next +
            "</span></button></div>"
        );
      }
      lightbox = $("#gallery-lightbox");
      lightbox.addClass("active");
      lightbox
        .find("figure")
        .html(
          tbaGalleryImages[tbaCurrentImageKey]["image"] +
            "<figcaption>" +
            tbaGalleryImages[tbaCurrentImageKey]["caption"] +
            "</figcaption>"
        );
      lightbox
        .find("figure")
        .find("img")
        .fadeOut(0)
        .css("max-height", $(window).height() * 0.8);
      lightbox
        .find("figure")
        .find("img")
        .fadeIn(500);
      lightbox.find("#gallery-close").trigger("focus");
    })
    .on("click", ".artist-title", function(e) {
      e.preventDefault();
      openArtist(e.target);
    })
    .on("click", ".artist-text-close", function(e) {
      e.preventDefault();
      closeArtist(e.target);
    });

  $(document).keyup(function(e) {
    switch (e.keyCode) {
      case 27: // esc
        closeGalleryOverlay();
        break;
    }
  });
}

function grayBackground() {
  if ($(".single-template .featured-image").length) {
    var topCalc = $(".featured-image").offset().top;
    $(".gray-background").css("top", topCalc);
  }
}

function headerScroll() {
  $(window).scroll(function() {
    if ($(window).scrollTop() >= 100) {
      $("#menuToggle").addClass("scrollHeader");
    } else {
      $("#menuToggle").removeClass("scrollHeader");
    }
  });
}
